import api from "../../../services/apiClient"
import type { AdminUserFormValues } from "../models/adminUser"

const BASE = "admin-users"

export const adminUserApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },
  getById: async (id: number) => {
    const { data } = await api.get(`${BASE}/${id}`)
    return data?.data ?? data
  },
  create: async (values: AdminUserFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },
  update: async (id: number, values: Partial<AdminUserFormValues>) => {
    const { data } = await api.post(`${BASE}/update/${id}`, values)
    return data?.data ?? data
  },
  delete: async (id: number) => {
    const { data } = await api.delete(`${BASE}/delete/${id}`)
    return data
  },
  activate: async (id: number) => {
    const { data } = await api.post(`${BASE}/activate/${id}`)
    return data?.data ?? data
  },
  deactivate: async (id: number) => {
    const { data } = await api.post(`${BASE}/deactivate/${id}`)
    return data?.data ?? data
  },
  resetPassword: async (id: number, password: string) => {
    const { data } = await api.post(`${BASE}/reset-password/${id}`, { password })
    return data?.data ?? data
  },
  reset2fa: async (id: number) => {
    const { data } = await api.post(`${BASE}/reset-2fa/${id}`)
    return data?.data ?? data
  },
  getRoles: async (id: number) => {
    const { data } = await api.get(`${BASE}/${id}/roles`)
    return data?.data ?? data
  },
  assignRoles: async (id: number, payload: { assign: string[]; revoke: string[] }) => {
    const { data } = await api.post(`${BASE}/${id}/roles/assign`, payload)
    return data?.data ?? data
  },
}
